import { useNavigate } from "react-router";

import { StatCard } from "@design-system/StatCard/StatCard";

import { routes } from "@pages/routes";

import { useClientExtensionAdoptionRateStatQuery } from "./ClientExtensionAdoptionRateStat.g";

type Props = {
  clientId: string;
};

export const ClientExtensionAdoptionRateStat = ({ clientId }: Props) => {
  const navigate = useNavigate();

  const { data } = useClientExtensionAdoptionRateStatQuery({
    clientId,
  });

  const users = data?.clientEmployees?.edges?.length ?? 0;
  let activeUsers = 0;

  data?.clientEmployees?.edges?.filter((edge) => {
    if (edge?.node?.sessions?.totalCount && edge.node.sessions.totalCount > 0) {
      activeUsers += 1;
      return true;
    }
    return false;
  });

  const adoptionRate =
    users > 0 ? ((activeUsers / users) * 100).toFixed(0) : "0";

  const showExtensionInstallationModal = () => {
    navigate(
      routes.portal.clients.client.dashboard.extensionInstallation.$buildPath({
        params: { clientId },
      }),
    );
  };

  return (
    <StatCard
      icon="faChartSimple"
      title="Extension adoption rate"
      value={(adoptionRate ?? "0").toString() + "%"}
      onOpenDetails={
        adoptionRate !== "0" ? showExtensionInstallationModal : undefined
      }
    />
  );
};
